var am4TrackChart = require('./track-chart');
var am4ColorThemes = require('./color-themes');
var am4Legend = require('./components/legend');
var am4YearSlider = require('./components/yearslider');

var currentYear;

function updateData(chart, year, yearLabel, series, seriesData, yearSliderLabel) {
	if (currentYear !== year) {
		currentYear = year;
		yearLabel.text = yearSliderLabel + currentYear;

		for (var i = 0; i < series.length; i++) {
			series[i].dataFields.valueY = seriesData[i].Name + year;
		}

		chart.invalidateRawData();
	}
}

function createColumnSeries3D(chart, seriesData, valueY, yAxis, yAxisUnit, index) {
	var series = chart.series.push(new window.am4charts.ColumnSeries3D());
	series.dataFields.valueY = valueY;
	series.dataFields.categoryX = seriesData.XAxisName;
	series.name = seriesData.Name;
	series.clustered = false;
	series.columns.template.tooltipText = '{valueY.value} ' + yAxisUnit;
	series.columns.template.width = window.am4core.percent(50);
	series.yAxis = yAxis;
	series.columns.template.hoverOnFocus = true;
	series.itemReaderText = '{category} {name}: {valueY.value} ' + yAxisUnit;

	// pattern doesn't work in Edge
	var isEdge = window.navigator.userAgent.indexOf('Edge') > -1;

	if (index % 2 !== 0 && !isEdge) {
		series.columns.template.adapter.add('fill', function (fill, target) {
			var pattern = new window.am4core.LinePattern();
			pattern.width = 12;
			pattern.height = 12;
			pattern.backgroundFill = chart.colors.list[index];
			pattern.backgroundOpacity = 1;
			pattern.strokeWidth = 1;
			pattern.stroke = window.am4core.color('white');
			pattern.strokeOpacity = 0.6;
			pattern.rotation = 45;
			return pattern;
		});
	}

	return series;
}

function createYAxis(chart, yAxisLabel, isSecondaryYAxis, seriesData) {
	var yAxis = chart.yAxes.push(new window.am4charts.ValueAxis());
	yAxisLabel = yAxisLabel.replace('|', '\n');
	yAxis.title.text = yAxisLabel;
	yAxis.title.rotation = 0;
	yAxis.title.align = 'center';
	yAxis.title.valign = 'top';
	yAxis.title.dy = -45;
	yAxis.title.fontWeight = 600;
	yAxis.title.isMeasured = false;
	yAxis.renderer.line.strokeOpacity = 1;
	yAxis.renderer.line.strokeWidth = 4;
	yAxis.renderer.line.stroke = chart.colors.list[0];
	yAxis.renderer.labels.template.fill = chart.colors.list[0];
	yAxis.layout = 'absolute';
	yAxis.isMeasured = false;
	yAxis.x = -50;

	if (!seriesData.AutoScale) {
		yAxis.min = seriesData.MinValue;
		yAxis.max = seriesData.MaxValue;
	}

	if (isSecondaryYAxis === true) {
		yAxis.renderer.opposite = true;
		yAxis.renderer.grid.template.disabled = true;
		yAxis.renderer.line.stroke = chart.colors.list[1];
		yAxis.renderer.labels.template.fill = chart.colors.list[1];
		yAxis.title.rotation = 0;
		yAxis.x = 25;
	}

	yAxis.paddingLeft = 10;
	yAxis.paddingRight = 10;
	yAxis.layout = 'absolute';

	return yAxis;
}

function createXAxis(chart, category) {
	var xAxis = chart.xAxes.push(new window.am4charts.CategoryAxis());
	xAxis.dataFields.category = category;
	xAxis.renderer.grid.template.location = 0;
	xAxis.renderer.minGridDistance = 30;
	xAxis.renderer.grid.template.disabled = true;
	xAxis.renderer.minGridDistance = 10;

	return xAxis;
}

var handleResponsiveCategoryLabels = function (xAxis) {
	var label = xAxis.renderer.labels.template;
	var labelMaxWidth = 100;
	label.maxWidth = labelMaxWidth;

	xAxis.events.on('sizechanged', function (ev) {
		var axis = ev.target;
		var cellWidth = axis.pixelWidth / (axis.endIndex - axis.startIndex);
		axis.renderer.labels.template.maxWidth = cellWidth;

		if (cellWidth < labelMaxWidth) {
			axis.renderer.labels.template.rotation = 315;
			axis.renderer.labels.template.verticalCenter = 'middle';
			axis.renderer.labels.template.horizontalCenter = 'right';
			label.wrap = false;
		} else {
			axis.renderer.labels.template.rotation = 0;
			axis.renderer.labels.template.horizontalCenter = 'middle';
			label.wrap = true;
		}
	});
};

function createSeries(chart, seriesData, $graphblock, yAxis, yAxisSecondary, yearData, showDoubleYAxis) {
	var seriesArray = [];

	for (var i = 0; i < seriesData.length; i++) {
		var columnSeries;
		var valueY = seriesData[i].Name + yearData.End;
		var yAxisUnit = $graphblock.data('yaxisunit');
		if (i % 2 !== 0 && showDoubleYAxis) {
			yAxisUnit = $graphblock.data('secondaryyaxisunit');
			columnSeries = createColumnSeries3D(chart, seriesData[i], valueY, yAxisSecondary, yAxisUnit, i);
		} else {
			columnSeries = createColumnSeries3D(chart, seriesData[i], valueY, yAxis, yAxisUnit, i);
		}
		am4TrackChart.trackColumnSeriesTooltip(columnSeries, $graphblock.data('chartname'));
		seriesArray.push(columnSeries);
	}

	return seriesArray;
}

module.exports = {
	createBar3DChart: function ($graphblock, data) {
		/* jshint ignore:start */
		window.am4core.useTheme(window.am4themes_animated);
		/* jshint ignore:end */

		var chart = window.am4core.create($graphblock.attr('id'), window.am4charts.XYChart3D);
		var seriesData = $graphblock.data('chartdata').Series;
		chart.data = data;
		chart.colors.list = am4ColorThemes.getChartColorTheme($graphblock.data('charttype'));

		if (seriesData.length > 1) {
			am4Legend.createLegend(chart);
		}

		chart.focusFilter.stroke = window.am4core.color('#f59a00');
		chart.focusFilter.strokeWidth = 6;

		chart.padding(65, 70, 0, 70);

		var yAxis = createYAxis(chart, $graphblock.data('yaxislabel'), false, seriesData[0]);
		var yAxisSecondary;
		var xAxis = createXAxis(chart, seriesData[0].XAxisName);
		var yearData = {
			Start: parseInt($graphblock.data('chartdata').Start),
			End: parseInt($graphblock.data('chartdata').End)
		};

		handleResponsiveCategoryLabels(xAxis);

		var showDoubleYAxis = $graphblock.data('showdoubleyaxis').toLowerCase() === 'true';
		if (showDoubleYAxis) {
			yAxisSecondary = createYAxis(chart, $graphblock.data('secondaryyaxislabel'), true, seriesData[1]);
		}

		var columnSeriesArray = createSeries(chart, seriesData, $graphblock, yAxis, yAxisSecondary,
			yearData, showDoubleYAxis);

		var yearSliderLabel = $graphblock.data('yearsliderlabel');
		if (yearData.Start !== yearData.End) {
			var yearSlider = am4YearSlider.createYearSlider(chart, yearData, columnSeriesArray,
				seriesData, yearSliderLabel, updateData, 1);
			am4TrackChart.trackYearSlider(yearSlider, $graphblock.data('chartname'));
		}

		return chart;
	}
};
